import React from "react";
import LaundryGuy from "../../../assets/images/laundry-guy.png";
import Pointer from "../../../assets/images/pointer.png";

const WhyChooseUs = () => {
  return (
    <section className="w-full bg-[#F6F6F6] py-20 font-[inter] scroll-mt-[90px] max-xl:px-20">
      <div className="max-w-[1150px] mx-auto px-6 lg:px-0 grid lg:grid-cols-2 gap-12 items-center">

        {/* ================= LEFT CONTENT ================= */}
        <div>
          <h2 className="text-[32px] md:text-[36px] font-semibold mb-4">
            Why Choose Us?
          </h2>

          <p className="text-[#8D8D90] max-w-[480px] leading-relaxed mb-10">
            Experience the ultimate laundry and dry-cleaning service with our trusted
            network of vendors and delivery partners. We provide top-quality, convenient,
            and reliable laundry solutions designed to make your life easier.
          </p>

        {/* FEATURES GRID */}
        <div className="grid gap-8 sm:grid-cols-2">

        {/* Experience */}
        <div className="flex items-start gap-3">
            <img src={Pointer} className="w-[20px] mt-1" alt="Tick Icon" />
            <div>
            <h4 className="font-semibold text-[18px] mb-1">Experience</h4>
            <p className="text-[14px] text-black leading-relaxed">
                With years of expertise, our professionals handle every garment with
                care — ensuring spotless results every time.
            </p>
            </div>
        </div>

        {/* Quality */}
        <div className="flex items-start gap-3">
            <img src={Pointer} className="w-[20px] mt-1" alt="Tick Icon" />
            <div>
            <h4 className="font-semibold text-[18px] mb-1">Quality</h4>
            <p className="text-[14px] text-black leading-relaxed">
                We use advanced cleaning techniques and premium detergents to keep
                your clothes fresh, clean, and perfectly maintained.
            </p>
            </div>
        </div>

        {/* Flexibility */}
        <div className="flex items-start gap-3">
            <img src={Pointer} className="w-[20px] mt-1" alt="Tick Icon" />
            <div>
            <h4 className="font-semibold text-[18px] mb-1">Flexibility</h4>
            <p className="text-[14px] text-black leading-relaxed">
                Choose your preferred pickup and delivery time—dry-clean, steam-iron,
                or wash services that fit your schedule.
            </p>
            </div>
        </div>

        {/* Satisfaction */}
        <div className="flex items-start gap-3">
            <img src={Pointer} className="w-[20px] mt-1" alt="Tick Icon" />
            <div>
            <h4 className="font-semibold text-[18px] mb-1">Satisfaction</h4>
            <p className="text-[14px] text-black leading-relaxed">
                Your satisfaction is our top priority—fast service, transparent
                pricing, and hassle-free delivery every time.
            </p>
            </div>
        </div>

</div>
        </div>

        {/* ================= RIGHT IMAGE ================= */}
        <div className="relative flex justify-center lg:justify-end">

          {/* Main Image */}
          <img
            src={LaundryGuy}
            alt="Laundry Service"
            className="w-full max-w-[450px] rounded-[20px]"
          />
        </div>

      </div>
    </section>
  );
};

export default WhyChooseUs;
